import { render, staticRenderFns } from "./WorkOrderProcedures.vue?vue&type=template&id=059e52a4&scoped=true"
import script from "./WorkOrderProcedures.vue?vue&type=script&lang=js"
export * from "./WorkOrderProcedures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059e52a4",
  null
  
)

export default component.exports